import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('isalon_cookie_consent');
    if (!cookieConsent) {
      // Show banner after a short delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('isalon_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('isalon_cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[60] animate-slideUp">
      <div className="bg-zinc-900 border-t border-white/10 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1 pr-4">
              <p className="text-white/90 font-sans text-sm leading-relaxed">
                We use cookies to enhance your browsing experience and analyse site traffic. By clicking "Accept All", you consent to our use of cookies. 
                <a 
                  href="/privacy-policy" 
                  className="text-isalonuk-accent hover:underline ml-1"
                >
                  Learn more
                </a>
              </p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <Button
                onClick={declineCookies}
                variant="outline"
                size="sm"
                className="border-white/20 text-white/70 hover:bg-white/10 hover:text-white rounded-full px-4"
              >
                Decline
              </Button>
              <Button
                onClick={acceptCookies}
                size="sm"
                className="bg-isalonuk-accent hover:bg-isalonuk-accent-hover text-black font-medium rounded-full px-6"
              >
                Accept All
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
